import type {
  LeavePreview,
  PendingWorkspaceInvitationResponse,
  WorkspaceMemberResponse,
  WorkspaceResponse,
} from '@/model/workspace/dto.generated';
import type {
  InvitationEntryView,
  LeavePreviewView,
  MemberEntryView,
  SidebarPlan,
  SidebarWorkspaceView,
} from '@/viewmodel/features/workspace/types';

export const toMemberEntry = (member: WorkspaceMemberResponse): MemberEntryView => ({
  userId: member.user_id,
  email: member.email,
  role: member.role,
});

export const toInvitationEntry = (
  invitation: PendingWorkspaceInvitationResponse,
): InvitationEntryView => ({ id: invitation.id, email: invitation.invitee_email });

export const memberDisplayName = (member: MemberEntryView): string =>
  member.email || `${member.userId.slice(0, 12)}…`;

export const toLeavePreviewView = (preview: LeavePreview | null): LeavePreviewView | null =>
  preview && {
    deletesTarget: !!preview.deletes_workspace || !!preview.deletes_project,
    requiresNewOwner: !!preview.requires_new_owner,
    ownerOptions: (preview.owner_candidates ?? []).map((candidate) => ({
      label: candidate.email ?? candidate.user_id ?? '',
      value: candidate.user_id ?? '',
    })),
  };

export const toSidebarWorkspace = (
  workspace: WorkspaceResponse | null | undefined,
  plan: SidebarPlan | null = null,
): SidebarWorkspaceView | null => {
  if (!workspace) return null;
  const name = workspace.name ?? '';
  return {
    name,
    initial: name.trim().charAt(0).toUpperCase() || 'W',
    tier: plan?.label ?? workspace.subscription_tier ?? '',
    locked: plan?.locked ?? false,
  };
};
